import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslatePipe } from './translate.pipe';
import { PropertyFilterPipe } from './property-filter.pipe';
import { StringFormatPipe } from '@app/shared/pipes/stringFormat.pipe';
import { BeautifyListPipe } from './beautify-lis.pipe';
import { MyFilterPipe } from './filter-pipe';

const pipes = [
    TranslatePipe,
    PropertyFilterPipe,
    StringFormatPipe,
    BeautifyListPipe,
    MyFilterPipe
];

@NgModule({
    imports: [CommonModule],
    declarations: [...pipes],
    providers: [...pipes],
    exports: [...pipes]
})
export class PipesModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/pipes/pipes.module.ts